import SearchModal from "../../mosaic/components/ModalSearch.jsx";
import Notifications from "../../mosaic/components/DropdownNotifications.jsx";
import Help from "../../mosaic/components/DropdownHelp.jsx";
import ThemeToggle from "../../mosaic/components/ThemeToggle.jsx";
import {useState} from "react";
import UserDropdown from "./Dropdown/UserDropdown.jsx";

function Header({sidebarOpen, setSidebarOpen}) {
    const [searchModalOpen, setSearchModalOpen] = useState(false);

    return (
        <header
            className="navbar sticky top-0 before:absolute before:inset-0 before:backdrop-blur-md before:bg-white/90 dark:before:bg-gray-800/90 lg:before:bg-gray-100/90 dark:lg:before:bg-gray-900/90 before:-z-10 max-lg:shadow-sm z-30">
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-16 lg:border-b border-gray-200 dark:border-gray-700/60">

                    {/* Header: Left side */}
                    <div className="flex">

                        {/* Hamburger button */}
                        <button
                            className="text-slate-500 hover:text-slate-600 lg:hidden"
                            aria-controls="sidebar"
                            aria-expanded={sidebarOpen}
                            onClick={(e) => {
                                e.stopPropagation();
                                setSidebarOpen(!sidebarOpen);
                            }}
                        >
                            <span className="sr-only">Open sidebar</span>
                            <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24"
                                 xmlns="http://www.w3.org/2000/svg">
                                <rect x="4" y="5" width="16" height="2"/>
                                <rect x="4" y="11" width="16" height="2"/>
                                <rect x="4" y="17" width="16" height="2"/>
                            </svg>
                        </button>

                    </div>

                    {/* Header: Right side */}
                    <div className="flex items-center space-x-3">
                        <ThemeToggle/>
                        {/*  Divider */}
                        <hr className="w-px h-6 bg-slate-200 dark:bg-slate-700 border-none"/>
                        <UserDropdown align="right"/>

                    </div>

                </div>
            </div>
        </header>
    );
}

export default Header;
